import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { Storage } from '@ionic/storage';

import { PunchCard } from '../../models/punch-card';
import { ConsumerPunchCardHandler } from '../../providers/consumer-punch-card-handler';
import { ConsumerPunchCardQrPage } from '../consumer-punch-card-qr/consumer-punch-card-qr';
import { ConsumerPunchCardTermsPage } from '../consumer-punch-card-terms/consumer-punch-card-terms';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-consumer-punch-card-manager',
  templateUrl: 'consumer-punch-card-manager.html',
})
export class ConsumerPunchCardManagerPage {
	punchCard: PunchCard;
	sequences: any;
	terms: any = [];
	hasTerms: boolean;
	hasSequences: boolean;
	hasPunches: boolean;
	private punchCardManagerForm : FormGroup;
	public imageSrc: string;
	loader: any;
	filePath: any;
	qrCodeUrl: any;
	userId: any;

	punchRefreshDone: boolean = false;
	leftView: boolean = false;
	
	punchItemGeneratedCount: any = 0;
	currentMasterId: any = '';
	punchCardSummary: any = 'Punch card summary';

	isLoading: boolean = false;

	previousPunchCount: any = 0;
	previousRewardCount: any = 0;
	rewardCount: any = 0;

	firstLoadHappened: boolean = false;

	apiCallQty: any = 0;

	punchCardDetail: any;	

  	constructor(
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public punchCardManagerHandler: ConsumerPunchCardHandler,
		public storage: Storage,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,
		public globals: Globals,
		public actionSheetCtrl: ActionSheetController,
		) {
		// this.filePath = this.globals.fileUrl;

		this.punchCard = navParams.get('punchCard');
		
	    this.punchCardManagerForm = this.formBuilder.group({
	    	"Id": [''],
		  	"PunchCardName":  ['', Validators.required],
		  	"ImagePath":  [''],
		    "IsPublished": [true],
		    "IsActive": [true]
	   	});   
	}

	ionViewDidEnter() {
		this.leftView = false;

	   	if(this.punchCard.Id != ''){
	   		this.loadPunchCard(this.punchCard.Id);   
	    } else {
	    	this.sequences = []
	    }		
	}	

	ionViewDidLeave(){
		this.leftView = true;
	}		

	loadPunchCard(id){
		if(!this.punchRefreshDone){
			this.isLoading = true;			
		}

		this.punchCardManagerHandler.getPunchCardSequencesByPunchCardId(id, (result)=>{		
			if(!this.punchRefreshDone){
				this.isLoading = false;			
			}		 

			this.punchCardDetail = result;

			this.doshit(result);

	  		if(this.leftView==false){
		   		setTimeout(()=>{
		   			if(this.leftView==false){
		   				this.punchRefreshDone = true;
		   				this.apiCallQty++;
		   				this.reloadSequences(id);
		   			}			   			
		   		}, 2000);	 				  			
	  		}  				  	
		})	
	}

	reloadSequences(id){
		if(this.apiCallQty==15){
			this.leftView = true;
			this.close();
		}else{
			this.punchCardManagerHandler.getSequencesByPunchCardId(id, (result)=>{		
				if(!this.punchRefreshDone){
					this.isLoading = false;			
				}		 

				this.punchCardDetail.rewardCount = result.rewardCount;
				this.punchCardDetail.punchCardSequenceList = result.punchCardSequenceList;

				if(this.previousPunchCount != this.getTotalUserPunchSumRefresh()){
					console.log("Doing shit")
					this.doshit(this.punchCardDetail);					
				}

		  		if(this.leftView==false){
			   		setTimeout(()=>{
			   			if(this.leftView==false){
			   				this.punchRefreshDone = true;
			   				this.apiCallQty++;
			   				this.reloadSequences(id);
			   			}			   			
			   		}, 2000);	 				  			
		  		}  				  	
			})	
		}		
	}

	doshit(result){
		if(this.currentMasterId != result.punchCardSequenceList[0].MasterId && this.currentMasterId!='' && this.currentMasterId!=null){
			this.previousPunchCount = 0;
		}

		this.currentMasterId = result.punchCardSequenceList[0].MasterId;

	  	if(
	  		this.previousPunchCount < result.punchCardSequenceList[0].TotalNeededPunches 
	  		|| 
	  		this.previousPunchCount == 0
	  	){
	  		this.punchItemGeneratedCount = 0;

	  		this.punchCard = result.punchCard;

	  		this.punchCardManagerForm.patchValue(
	    		this.punchCard
	    	)	

	    	this.sequences = result.punchCardSequenceList;

	    	this.terms = result.punchCardTermsList;

	    	if(this.terms && this.terms.length > 0) {
	    		this.hasTerms = this.terms[0] != "";
	    	}
	    	
	    	this.rewardCount = result.rewardCount

	    	this.configureTerms();

	    	this.configureSequence();

	  		this.filePath = this.globals.fileUrl + this.punchCard.ImagePath;

	  		this.qrCodeUrl =  this.globals.dataUrl + "qrcode/" + this.punchCard.Id + '~' + this.sequences[0].UserId;		   

	    	this.hasSequences = this.sequences.length > 0;

	    	if(this.hasSequences){
				this.alertUserForNewPunch();

	    		this.previousPunchCount = this.getTotalUserPunchSum();	
	    		this.previousRewardCount = this.rewardCount;

	    		this.firstLoadHappened = true;
	    	} 			  	
	  	}		
	}

	configureTerms(){
		var terms = this.terms, termsArr = [];

		for (var i = terms.length - 1; i >= 0; i--) {
			if(terms[i].Terms!=null && terms[i].Terms!=""){
				termsArr.push(terms[i].Terms);
			}			
		}

		this.terms = termsArr;
	}

	getTotalUserPunchSum(){
		var returnVal = 0;
		var sequences = this.punchCardDetail.punchCardSequenceList;

		for (var i = this.punchCardDetail.punchCardSequenceList.length - 1; i >= 0; i--) {
			returnVal += this.sequences[i].TotalUserPunches
		}

		return returnVal;
	}

	getTotalUserPunchSumRefresh(){
		var returnVal = 0;
		var sequences = this.punchCardDetail.punchCardSequenceList;
		
		for (var i = sequences.length - 1; i >= 0; i--) {
			returnVal += sequences[i].TotalUserPunches
		}

		return returnVal;
	}	

	alertUserForNewPunch(){
		console.log("Before alert")
		console.log("this.rewardCount = " + this.rewardCount)		

		if(this.previousRewardCount != this.rewardCount && this.rewardCount > 0 && this.firstLoadHappened==true){
			console.log("Alerted of new reward")

			let alert = this.alertCtrl.create({
				title: 'Reward gained',
				subTitle: 'You just won a reward! Go to the redeemables area to find your new reward.',
				buttons: ['Ok']
			});

			alert.present();		
		}else{
			console.log("Alerted of card stamped")

			if(this.previousPunchCount < this.getTotalUserPunchSum() && this.punchRefreshDone == true){
				let alert = this.alertCtrl.create({
					title: 'Card stamped',
					subTitle: 'You stamped this card. Keep at it to win awesome stuff!',
					buttons: ['Ok']
				});

				alert.present();		
			}			
		}
	}

	configureSequence(){
		var sequencePunchSum = 0;
		var totalPunches = 0;

		//Setup punches
		for (var i = 0; i < this.sequences.length; i++) {
			let sequence = this.sequences[i];

			sequence.punches = this.createPunchArray(
				sequence.PunchQuantity, 
				sequence.TotalUserPunches, 
				sequence.PunchCardSequenceId
			)

			//Mark sequences as done
			sequence.punchesLeft = (sequence.PunchQuantity > sequence.TotalUserPunches) ? true : false;
			sequencePunchSum+= sequence.TotalUserPunches;

			totalPunches = sequence.TotalNeededPunches;
		}

		this.punchCardSummary = sequencePunchSum + " punches of " + totalPunches + " done. Keep at it!";
	}

	createPunchArray(sequencePunchQuantity, sequenceUserPunchCount, id){
		var punches = [];

		for (var i = 0; i < sequencePunchQuantity; i++) { 
		    punches.push({
		        id: i + 1,
		        punched: (sequenceUserPunchCount>=i+1) ? true : false
		    });
		}	

		return punches;	
	}

	calcRemainingPunchesToReward(sequence){
		return sequence.PunchQuantity - sequence.TotalUserPunches;
	}

	managePunchCardQr($e, punchCard){
	    this.navCtrl.push(ConsumerPunchCardQrPage, {
	      qrCodeUrl: this.qrCodeUrl,
	      punchCardId: this.punchCard.Id
	    });				
	}

	viewTerms($e, punchCard){
		this.navCtrl.push(ConsumerPunchCardTermsPage, {
	      punchCard: punchCard,
	      terms: this.terms
	    });
	}

  	close(){
		this.viewCtrl.dismiss();
  	}
}


// WEBPACK FOOTER //
// ./src/pages/consumer-punch-card-manager/consumer-punch-card-manager.ts